export const isEmpty = (val: string) => {
  return val.replace(/^(\s*)|(\s*$)/gi, '') == '';
};

export const isValidEmail = (val?: string) => {
  if (!val) return false;

  const email_regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return email_regex.test(val.toLowerCase());
  // 이전 정규식
  // var reg = /^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{2,5}$/;
  // return reg.test(val);
};

export const isValidPassword = (val: string) => {
  const password_regex = /((?=.*\d)(?=.*[a-zA-Z])(?=.*[{}[\]/?.,;:|)*~`!^\-_+<>@#$%&\\=('"]))/;
  return password_regex.test(val);
};

export const isSpecialString = (val) => {
  const reg = /[~!@#$%^&*()'"_+|<>?:{}]/;
  return reg.test(val);
};

export const checkPhoneNumberSms = (number: string) => {
  const chk_number = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
  return chk_number.test(number);
};

export const checkPassword = function (password: string, email: string) {
  if (password.length < 10 || !isValidPassword(password)) {
    return 'invalid';
  }

  if (/(\w)\1\1\1/.test(password)) {
    return 'consecutive_char';
  }

  if (password.search(email.split('@')[0]) > -1) {
    return 'email';
  }

  let ascSeqCharCnt = 0; // 오름차순 연속 문자 카운트
  let descSeqCharCnt = 0; // 내림차순 연속 문자 카운트

  for (let i = 0; i < password.length; i++) {
    // charAt(): 문자값 반환
    const char_0 = password.charAt(i);
    const char_1 = password.charAt(i + 1);
    const char_2 = password.charAt(i + 2);

    // charCodeAt(): 유니코드값 반환
    const diff_0_1 = char_0.charCodeAt(0) - char_1.charCodeAt(0);
    const diff_1_2 = char_1.charCodeAt(0) - char_2.charCodeAt(0);

    if (diff_0_1 === 1 && diff_1_2 === 1) {
      ascSeqCharCnt += 1;
    }

    if (diff_0_1 === -1 && diff_1_2 === -1) {
      descSeqCharCnt += 1;
    }

    if (ascSeqCharCnt > 1 || descSeqCharCnt > 1) {
      return 'consecutive_char';
    }
  }
};

export const getPasswordError = (key: 'invalid' | 'consecutive_char' | 'email') => {
  const errors = {
    invalid: {
      title: ET('mps2::signup::invalid_password_error'),
      message: ET('mps2::signup::invalid_password_error_message'),
    },
    consecutive_char: {
      title: ET('mps2::signup::consecutive_char_error'),
      message: ET('mps2::signup::consecutive_char_error_message'),
    },
    email: {
      title: ET('mps2::signup::email_password_error'),
      message: ET('mps2::signup::email_password_error_message'),
    },
  };

  return errors[key];
};

export function isValidInt(value: unknown): value is number {
  const MIN_INT = -2147483648;
  const MAX_INT = 2147483647;

  return typeof value === 'number' && Number.isInteger(value) && value >= MIN_INT && value <= MAX_INT;
}
